import type { ServiceCategory } from '@makhe/shared';

// "How long does it last" is a real buying signal for some beauty services
// (protective styles, gel sets, lash sets) but meaningless for others (makeup
// is event-based; a fresh cut just grows out). We only collect and surface
// wear-life for the categories below — each with its typical range so the
// average has something to be measured against.
export interface WearLifeMeta {
  noun: string; // how we refer to the result, e.g. "this style"
  min: number; // typical low end, in weeks
  max: number; // typical high end, in weeks
  scaleMax: number; // right edge of the longevity bar
  prompt: string; // question asked in the review modal
  options: number[]; // quick-pick week values offered to the reviewer
}

export const WEAR_LIFE: Partial<Record<ServiceCategory, WearLifeMeta>> = {
  hair: {
    noun: 'this style',
    min: 4,
    max: 8,
    scaleMax: 10,
    prompt: 'How long did your style last?',
    options: [1, 2, 4, 6, 8, 10],
  },
  nails: {
    noun: 'this set',
    min: 2,
    max: 4,
    scaleMax: 6,
    prompt: 'How long did your set last?',
    options: [1, 2, 3, 4, 5, 6],
  },
  brows_lashes: {
    noun: 'this set',
    min: 2,
    max: 4,
    scaleMax: 6,
    prompt: 'How long did it last before a fill?',
    options: [1, 2, 3, 4, 5, 6],
  },
};

export const wearLifeFor = (category: ServiceCategory): WearLifeMeta | null =>
  WEAR_LIFE[category] ?? null;
